import postsActionTypes from './action-types';

export const fetchPostsList = payload => ({
  type: postsActionTypes.FETCH_POSTS_LIST,
  payload,
});

export const fetchPostsListSuccess = payload => ({
  type: postsActionTypes.FETCH_POSTS_LIST_SUCCESS,
  payload,
});

export const fetchPostsListFail = payload => ({
  type: postsActionTypes.FETCH_POSTS_LIST_FAIL,
  payload,
});

export const fetchAddOrEditPostSubmission = payload => ({
  type: postsActionTypes.FETCH_ADD_OR_EDIT_POST_SUBMISSION,
  payload,
});

export const fetchAddOrEditPostSubmissionSuccess = payload => ({
  type: postsActionTypes.FETCH_ADD_OR_EDIT_POST_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddOrEditPostSubmissionFail = payload => ({
  type: postsActionTypes.FETCH_ADD_OR_EDIT_POST_SUBMISSION_FAIL,
  payload,
});

export const fetchDeletePostSubmission = payload => ({
  type: postsActionTypes.FETCH_DELETE_POST_SUBMISSION,
  payload,
});

export const fetchDeletePostSubmissionSuccess = payload => ({
  type: postsActionTypes.FETCH_DELETE_POST_SUBMISSION_SUCCESS,
  payload,
});

export const fetchDeletePostSubmissionFail = payload => ({
  type: postsActionTypes.FETCH_DELETE_POST_SUBMISSION_FAIL,
  payload,
});

export const fetchRssFeedList = payload => ({
  type: postsActionTypes.FETCH_RSS_FEED_LIST,
  payload,
});

export const fetchRssFeedListSuccess = payload => ({
  type: postsActionTypes.FETCH_RSS_FEED_LIST_SUCCESS,
  payload,
});

export const fetchRssFeedListFail = payload => ({
  type: postsActionTypes.FETCH_RSS_FEED_LIST_FAIL,
  payload,
});

export const fetchAddRssFeedSubmission = payload => ({
  type: postsActionTypes.FETCH_ADD_RSS_FEED_SUBMISSION,
  payload,
});

export const fetchAddRssFeedSubmissionSuccess = payload => ({
  type: postsActionTypes.FETCH_ADD_RSS_FEED_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddRssFeedSubmissionFail = payload => ({
  type: postsActionTypes.FETCH_ADD_RSS_FEED_SUBMISSION_FAIL,
  payload,
});

export const fetchEditRssFeedSubmission = payload => ({
  type: postsActionTypes.FETCH_EDIT_RSS_FEED_SUBMISSION,
  payload,
});

export const fetchEditRssFeedSubmissionSuccess = payload => ({
  type: postsActionTypes.FETCH_EDIT_RSS_FEED_SUBMISSION_SUCCESS,
  payload,
});

export const fetchEditRssFeedSubmissionFail = payload => ({
  type: postsActionTypes.FETCH_EDIT_RSS_FEED_SUBMISSION_FAIL,
  payload,
});
